<template>
  <b-container class="home-image-hover">
    <div v-if="image == '' || image == null"></div>
    <div v-else>
      <img :src="image" alt="Image" id="image" />
      <!-- {{image}} -->
    </div>
  </b-container>
</template>
<script>
export default {
  name: "HomeImageHover",
  props: {
    image: String,
  },
};
</script>
<style scoped>
img {
  max-height: 400px !important;
  min-height: 400px !important;
  min-width: 1360px !important;
}
</style>
